import { MutationTree } from "vuex";
import { State} from "@/store/types";

export const mutations: MutationTree<State> = {

};
